export function getAuthBootstrapState({ authResolved, hasSession, profileResolved }) {
  if (!authResolved) return 'loading-session';
  if (hasSession && !profileResolved) return 'loading-profile';
  return hasSession ? 'authenticated' : 'public';
}

export function getAuthenticatedSessionTransition({ activeUserId, incomingUserId }) {
  const previousId = activeUserId == null ? null : String(activeUserId);
  const nextId = incomingUserId == null ? null : String(incomingUserId);
  const userChanged = previousId !== nextId;

  return {
    userChanged,
    shouldRefreshProfile: Boolean(nextId && userChanged),
    shouldNavigateToDashboard: Boolean(nextId && userChanged),
  };
}
